var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 61.2576C33.4295 62.5973 30.5705 62.5973 28.25 61.2576L8.53719 49.8764C6.21668 48.5366 4.78719 46.0607 4.78719 43.3812L4.78719 20.6188C4.78719 17.9393 6.21668 15.4634 8.53719 14.1236L28.25 2.74242C30.5705 1.40267 33.4295 1.40267 35.75 2.74242L55.4628 14.1236C57.7833 15.4634 59.2128 17.9393 59.2128 20.6188L59.2128 43.3812C59.2128 46.0607 57.7833 48.5366 55.4628 49.8764L35.75 61.2576Z",
    fill: "white",
    className: "white-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 61.2576C33.4295 62.5973 30.5705 62.5973 28.25 61.2576L8.53719 49.8764C6.21668 48.5366 4.78719 46.0607 4.78719 43.3812L4.78719 20.6188C4.78719 17.9393 6.21668 15.4634 8.53719 14.1236L28.25 2.74242C30.5705 1.40267 33.4295 1.40267 35.75 2.74242L55.4628 14.1236C57.7833 15.4634 59.2128 17.9393 59.2128 20.6188L59.2128 43.3812C59.2128 46.0607 57.7833 48.5366 55.4628 49.8764L35.75 61.2576Z",
    fill: "white",
    className: "white-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 61.2576C33.4295 62.5973 30.5705 62.5973 28.25 61.2576L8.53719 49.8764C6.21668 48.5366 4.78719 46.0607 4.78719 43.3812L4.78719 20.6188C4.78719 17.9393 6.21668 15.4634 8.53719 14.1236L28.25 2.74242C30.5705 1.40267 33.4295 1.40267 35.75 2.74242L55.4628 14.1236C57.7833 15.4634 59.2128 17.9393 59.2128 20.6188L59.2128 43.3812C59.2128 46.0607 57.7833 48.5366 55.4628 49.8764L35.75 61.2576Z",
    stroke: "#1C174C",
    className: "dark-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33.7321C22.6667 32.9623 22.6667 31.0377 24 30.2679L36 23.3397C37.3333 22.5699 39 23.5322 39 25.0718V38.9282C39 40.4678 37.3333 41.4301 36 40.6603L24 33.7321Z",
    fill: "#1C174C",
    className: "dark-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollL);
export default __webpack_public_path__ + "static/media/scroll_L.0c32acf78b5f6e40a7bfde17e4a8ca49.svg";
export { ForwardRef as ReactComponent };